import request from "@/utils/request";

// 申请入驻
export function apply(data) {
  return request({
    method: "post",
    path: "supplier/apply",
    data,
  });
}
